import { Button } from "@chakra-ui/react";
import { CalendarIcon } from "lucide-react";
import Link from "next/link";

export const ScheduleFreeDiscoveryCallButton = ({
  label,
  variant = "primary",
}: {
  label: string;
  variant?: "primary" | "secondary";
}) => {
  return (
    <Link href="#schedule">
      <Button
        size="lg"
        fontSize="2xl"
        w={{
          base: "full",
          md: "auto",
        }}
        variant={variant}
        leftIcon={<CalendarIcon />}
      >
        {label}
      </Button>
    </Link>
  );
};
